import { call, put, select, all, delay } from 'redux-saga/effects';
import { FetchActionByContextRequestAction, FetchLinkedActionsRequestAction } from '../../types/types';
import { getItems } from 'src/modules/spItems/actions';
import { selectItems } from 'src/modules/spItems/selectors';
import { myTaskActionsListName } from 'src/api/config/myTasksActions.config';
import { fetchDataByContext, fetchReportActions } from '../../api/strapiGop';
import { fetchActionByContextFailure, fetchActionByContextSuccess, fetchLinkedActionsFailure, fetchLinkedActionsSuccess } from './actions';

//! Функция для извлечения ID из хэштега не удалять
// function extractIdFromHashTag(hashTag: string): number | null {
//   const match = hashTag.match(/#GOPСтандарты_(\d+)/);
//   return match ? parseInt(match[1], 10) : null;
// }

function extractIdFromHashTag(hashTag: string): number | null {
  const match = hashTag.match(/#GOPСтандарты_(\d+)/);
  if (match) {
    const extractedId = parseInt(match[1], 10);
    const adjustedId = extractedId; //!
    return adjustedId;
  }
  return null;
}

//! Функция для связывания действий
function linkActionsWithReportActions(allActions: any[], reportActions: any[]): any[] {
  return allActions.map((spAction) => {
    const reportActionId = extractIdFromHashTag(spAction.ImportantHashTag || '');

    if (reportActionId) {
      const linkedReportAction = reportActions.find((reportAction) => reportAction.id === reportActionId);

      if (linkedReportAction) {
        return {
          ...spAction,
          linkedReportAction,
          isLinked: true,
        };
      }
    }

    return {
      ...spAction,
      linkedReportAction: null,
      isLinked: false,
    };
  });
}

export function* fetchLinkedActionsSaga(action: FetchLinkedActionsRequestAction) {
  try {
    const { filters } = action.payload;

    yield put(
      getItems({
        listName: myTaskActionsListName,
        filters: { ImportantHashTag: `#${'GOPСтандарты'}*` },
      })
    );

    const [reportActions, allActions]: [any[], any[]] = yield all([call(fetchReportActions, filters), select((state) => selectItems(state, myTaskActionsListName))]);

    if (!allActions || allActions.length === 0) {
      yield delay(3000);
      const retryAllActions = yield select((state) => selectItems(state, myTaskActionsListName));

      if (retryAllActions && retryAllActions.length > 0) {
        const linkedActions = linkActionsWithReportActions(retryAllActions, reportActions);
        yield put(fetchLinkedActionsSuccess(linkedActions));
      } else {
        // console.log('Действия с шарика не пришли');
        const linkedActions = reportActions.map((action) => ({
          linkedReportAction: action,
          isLinked: true,
          fromStrapi: true,
        }));
        yield put(fetchLinkedActionsSuccess(linkedActions));
      }
    } else {
      const linkedActions = linkActionsWithReportActions(allActions, reportActions);
      yield put(fetchLinkedActionsSuccess(linkedActions));
    }
  } catch (error: any) {
    const errorMessage = error?.message || 'Ошибка при связывании действий';
    yield put(fetchLinkedActionsFailure(errorMessage));
  }
}
//! поиск действия для главной по context
export function* fetchActionByContextSaga(action: FetchActionByContextRequestAction) {
  try {
    const { modelName, context } = action.payload;
    const gopActions: any[] = yield call(fetchDataByContext, modelName, context);
    if (gopActions && gopActions.length > 0) {
      const actionIds = gopActions.map((action) => action.id);
      const hashTags = actionIds.map((id) => `#GOPСтандарты_${id}`);

      yield put(
        getItems({
          listName: myTaskActionsListName,
          filters: {
            ImportantHashTag: hashTags,
          },
        })
      );
      yield delay(500);

      //! Пока запланированые действия идут с шарика
      const spActions: any[] = yield select((state) => selectItems(state, myTaskActionsListName));

      const linkedActions = spActions.map((spAction) => {
        const matchingGopAction = gopActions.find((gopAction) => {
          const expectedHashTag = `#GOPСтандарты_${gopAction.id}`;
          return spAction.ImportantHashTag === expectedHashTag;
        });
        return {
          ...spAction,
          linkedGopAction: matchingGopAction,
          isLinked: !!matchingGopAction,
          context: context,
        };
      });
      const orphanedGopActions = gopActions
        .filter((gopAction) => {
          const expectedHashTag = `#GOPСтандарты_${gopAction.id}`;
          return !spActions.some((spAction) => spAction.ImportantHashTag === expectedHashTag);
        })
        .map((gopAction) => ({
          linkedGopAction: gopAction,
          isLinked: true,
          fromStrapi: true,
          context: context,
        }));

      const allActions = [...linkedActions, ...orphanedGopActions];
      yield put(fetchActionByContextSuccess(allActions));
    } else {
      yield put(fetchActionByContextSuccess([]));
    }
  } catch (error: any) {
    const errorMessage = error?.message || 'Ошибка при поиске действий';
    yield put(fetchActionByContextFailure(errorMessage));
  }
}
